import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-account-cell-renderer',
  templateUrl: './account-cell-renderer.component.html',
  styleUrls: ['./account-cell-renderer.component.scss']
})
export class AccountCellRendererComponent implements OnDestroy{
  mini: boolean;
  private destroy$ = new Subject<void>();
  availableChannels = {
    "Amazon": {
      url: "/assets/images/account-dropdown/amazon.png",
      width: "16px",
    },
    "Walmart": {
      url: "/assets/images/account-dropdown/walmart.png",
      width: "16px",
    },
    "Wholesale": {
      url: "/assets/images/account-dropdown/wholesale.png",
      width: "16px",
    }
  };
  channel: any;
  account: string;
  params: any;

  agInit(params: any): void {
    this.params = params;
    const channel=this.params.data.ShipTo ? this.params.data.ShipTo : this.params.data.Channel;
    this.channel = this.availableChannels[channel];
    this.account = this.params.data.Account ? this.params.data.Account : this.params.data.AccountName;   
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
